import { useMemo } from "react";
import { KPI_ROWS, fmtEur } from "@/lib/kpis";
import { cn } from "@/lib/utils";

const CONF = { haute: "text-emerald-700", moyenne: "text-amber-700", faible: "text-rose-700" };

function delta(cur, prev) {
    if (cur == null || prev == null || prev === 0) return null;
    return ((cur - prev) / Math.abs(prev)) * 100;
}

export default function KpiTable({ kpis }) {
    const metas = useMemo(() => kpis.filter((k) => k.donnees_extraites?.source || k.donnees_extraites?.commentaire), [kpis]);
    return (
        <div className="space-y-3">
            <div className="overflow-x-auto">
                <table data-testid="kpi-table" className="w-full text-sm">
                    <thead>
                        <tr className="text-left text-xs uppercase tracking-[0.14em] text-muted-foreground border-b border-border">
                            <th className="py-2 pr-4 font-medium">Indicateur</th>
                            {kpis.map((k) => (
                                <th key={k.annee_fiscale} data-testid={`kpi-year-${k.annee_fiscale}`} className="py-2 px-3 font-medium text-right">
                                    {k.annee_fiscale}
                                    {k.donnees_extraites?.date_cloture && <span className="block text-[10px] normal-case tracking-normal font-normal">clôture {k.donnees_extraites.date_cloture}</span>}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-border">
                        {KPI_ROWS.map((row) => (
                            <tr key={row.key} data-testid={`kpi-row-${row.key}`}>
                                <td className="py-3 pr-4 font-medium text-foreground">{row.label}</td>
                                {kpis.map((k, i) => {
                                    const v = k[row.key];
                                    const d = i > 0 ? delta(v, kpis[i - 1][row.key]) : null;
                                    return (
                                        <td key={k.annee_fiscale} className="py-3 px-3 text-right tabular-nums whitespace-nowrap">
                                            <span data-testid={`kpi-${row.key}-${k.annee_fiscale}`} className={cn("font-display text-lg whitespace-nowrap", v != null && v < 0 ? "text-rose-700" : "text-foreground")}>
                                                {fmtEur(v)}
                                            </span>
                                            {d != null && (
                                                <span className={cn("block text-[11px]", d >= 0 ? "text-emerald-700" : "text-rose-700")}>
                                                    {d >= 0 ? "+" : ""}{d.toFixed(1)} %
                                                </span>
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <ul className="space-y-1">
                {metas.map((k) => {
                    const m = k.donnees_extraites || {};
                    return (
                        <li key={k.annee_fiscale} data-testid={`kpi-meta-${k.annee_fiscale}`} className="text-xs text-muted-foreground">
                            <span className="font-medium text-foreground">{k.annee_fiscale}</span>
                            {m.source ? ` · ${m.source}` : ""}
                            {m.confiance && <span className={cn("ml-1 font-medium", CONF[m.confiance] || "")}>· confiance {m.confiance}</span>}
                            {m.commentaire ? ` — ${m.commentaire}` : ""}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
